export const PageType = {
    Home: '1',
    Location: '2',
    Design: '3',
    Apartment: '4',
    Amenity: '5',
    News: '6',
    Virtual360: '7',
    Contact: '8'
}